import { X } from "lucide-react";
import { Button } from "@akuna/ui";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import { RecentConsultationsCard } from "@/components/medical-records/RecentConsultationsCard";
import { AttendanceCarePanel } from "@/components/medical-records/AttendanceCarePanel";

interface MobilePatientContextSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  closeLabel: string;
  records: React.ComponentProps<typeof RecentConsultationsCard>["records"];
  isLoadingRecords: boolean;
  petId: string;
  ownerId?: string | null;
  clinicId: string | null;
}

export function MobilePatientContextSheet({
  open,
  onOpenChange,
  title,
  description,
  closeLabel,
  records,
  isLoadingRecords,
  petId,
  ownerId,
  clinicId,
}: MobilePatientContextSheetProps) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange} shouldScaleBackground={false}>
      <DrawerContent className="max-h-[88dvh] rounded-t-3xl bg-background-app">
        <div className="relative border-b border-border/50 p-4 pr-14 text-left">
          <DrawerTitle className="font-heading text-lg font-extrabold">{title}</DrawerTitle>
          <DrawerDescription className="mt-1">{description}</DrawerDescription>
          <DrawerClose asChild>
            <Button variant="ghost" size="icon" className="absolute right-3 top-3 h-9 w-9 rounded-full bg-card" aria-label={closeLabel}>
              <X className="h-4 w-4" />
            </Button>
          </DrawerClose>
        </div>
        <div className="min-h-0 space-y-4 overflow-y-auto p-4 pb-[max(24px,env(safe-area-inset-bottom))]">
          <RecentConsultationsCard records={records} isLoading={isLoadingRecords} maxItems={3} />
          <AttendanceCarePanel petId={petId} ownerId={ownerId} clinicId={clinicId} />
        </div>
      </DrawerContent>
    </Drawer>
  );
}
